
export const SENTRY_NO_OP_CHANNEL = 'sentry-no-op';
export const SENTRY_INFO_CHANNEL = 'sentry-info';